<!--

Changes done by 
-> Mangesh SuryaWanshi
-> Ajay Vijay Malekar

-->
<!-- actual form  -->
<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <h2 id="headings" class="main-headings">Cisco New Application Detector Request</h2>
        </div>
    </div>
</div>

    <form class="container-fluid" [formGroup]="uploadForm" (ngSubmit)="onSubmit()">
    <div class="small-container-white">   
   <div class="col-md-12">  <p>To submit a new application detector request you must be logged into your Cisco account.</p></div>
    <div class="row">
        <div class="col-md-4 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label class="label">Customer Contact</label>
                    <input id="sample1" type="text" class="input" formControlName="userName" name="userName" placeholder="ex. Customer Name" readonly
                    [ngClass]="{ 'input--state-danger': submitted && f.userName.errors }">
                    <div *ngIf="submitted && f.userName.errors" class="invalid-feedback">
                        <div *ngIf="f.userName.errors.required">User Name is required</div>
                    </div>
                </div>
            </div>    
        </div>   
         
        <div class="col-md-4 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label class="label">Customer Email</label>
                    <input type="text" class="input" formControlName="userEmail" name="userEmail" placeholder="ex: someome@cisco.com" readonly
                    [ngClass]="{ 'input--state-danger': submitted && f.userEmail.errors }">
                    <div *ngIf="submitted && f.userEmail.errors" class="invalid-feedback">
                        <div *ngIf="f.userEmail.errors.required">User Email is required</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-4 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label for="sample2" class="label">Customer Name</label>
                    <input id="sample2" type="text" class="input" formControlName="customerName" name="customerName"  placeholder="Customer Name">
                </div>
            </div>
        </div>
    </div>
    </div> 
  <div class="row" style="margin-top: 25px;"></div>
    <div class="small-container-white">   
    <div class="row">
        <div class="col-md-12">
            <h2 id="headings" class="sub-main-headings">Application Detector Details</h2>
        </div>
    </div>
    

    <div class="row">
        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label for="sample2" class="label">Application Name</label>
                    <input id="sample2" type="text" class="input" formControlName="appName" name="appName"  placeholder="ex. MFTP,Applejuice"
                    [ngClass]="{ 'input--state-danger': submitted && f.appName.errors }">
                    <div *ngIf="submitted && f.appName.errors" class="invalid-feedback">
                        <div *ngIf="f.appName.errors.required">Application Name is required</div>
                    </div>
                    <div *ngIf="f.appName.errors?.maxlength" class="invalid-feedback">Maximum 75 characters allowed </div>
                </div>
                

                <div class="form-group__text">
                    <label for="sample3" class="label">Application Detector Type</label>
                    <input id="sample3" type="text" class="input" formControlName="detectorType" name="detectorType" placeholder="web application, VPN, word processor"
                      [ngClass]="{ 'input--state-danger': submitted && f.detectorType.errors }">
                   <!--  <div class="help-block">
                        <span class="help-block__text">web application, VPN, word processor</span>
                    </div> -->
                    <div *ngIf="submitted && f.detectorType.errors" class="invalid-feedback">
                        <div *ngIf="f.detectorType.errors.required">Application Detector Type is required</div>
                    </div>
                    <div *ngIf="f.detectorType.errors?.maxlength" class="invalid-feedback">Maximum 45 characters allowed </div>
                </div>

                <div class="form-group__text">
                    <label for="sample4" class="label">Application Description</label>
                    <textarea rows="3" class="textarea" formControlName="appDescription" name="appDescription" placeholder="ex. Application Description details."
                    [ngClass]="{ 'input--state-danger': submitted && f.appDescription.errors }"></textarea>
                    <div *ngIf="submitted && f.appDescription.errors" class="invalid-feedback">
                        <div *ngIf="f.appDescription.errors.required">Application Description is required</div>
                    </div>
                </div>
                

                <div class="form-group__text">
                    <label for="sample3" class="label">Purpose of the application detector</label>
                    <textarea rows="3" class="textarea" formControlName="purposeOfDetector" name="purposeOfDetector" placeholder="ex. Purpose of the Application Detector."></textarea>
                </div>

                <div class="form-group__text">
                    <label for="sample3" class="label">Operating Systems that use the application</label>
                    <input id="sample3" type="text" class="input" 
                    formControlName="operatingSystem" name="operatingSystem" placeholder="Comma separated list ex. Windows, Android">
                    <!-- <div class="help-block">
                        <span class="help-block__text">Comma separated list ex. Windows, Android</span>
                    </div> -->
                    <div *ngIf="f.operatingSystem.errors?.maxlength" class="invalid-feedback">Maximum 45 characters allowed </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 col-sm-12">
            <div class="form-group">
                <div class="form-group__text">
                    <label for="sample3" class="label">Application Ports</label>
                    <input id="sample3" type="text" class="input"  formControlName="appPorts" name="appPorts" placeholder="Comma separated list ex. 8080, 8082, 8084">
                    <!-- <div class="help-block">
                        <span class="help-block__text">Comma separated list ex. 8080, 8082, 8084</span>
                    </div> -->
                    <div *ngIf="f.appPorts.errors?.maxlength" class="invalid-feedback">Maximum 45 characters allowed </div>
                </div>

                <div class="form-group__text">
                    <label class="checkbox">
                        <input type="checkbox" class="checkbox__input" formControlName="usesSSL" name="usesSSL">
                        <div class="checkbox__box"></div>
                        <div class="checkbox__label">Application uses SSL</div>
                    </label>
                    <label class="checkbox">
                        <input type="checkbox" class="checkbox__input" formControlName="requireDecryption" name="requireDecryption">
                        <div class="checkbox__box"></div>
                        <div class="checkbox__label">Application requires decryption</div>
                    </label>
                </div>

                <div class="form-group__text">
                    <label for="sample3" class="label">Online references</label>
                    <input id="sample3" type="text" class="input"  name="onlineReferences" formControlName="onlineReferences" placeholder="URL, installation link">
                   <!--  <div class="help-block">
                        <span class="help-block__text">URL, installation link</span>
                    </div> -->
                    <div *ngIf="f.onlineReferences.errors?.maxlength" class="invalid-feedback">Maximum 255 characters allowed </div>
                </div>


                <!-- <div class="form-group__text">
          <label for="sample5" class="label" >Application Traffic Capture (pcaps):</label>
          <div class="help-block">
            <span class="help-block__text">Upload pcap file</span>
          </div>
          <button class="btn btn--primary">Add File</button>
        </div> -->

        <div class="form-group__text">
            <label for="sample5" class="label" >Application Traffic Capture (pcaps)</label>
           
              <div class="file">
              <!-- actual upload which is hidden -->
              <input accept=".pcap" id="actual-btn" type="file" name="pcapFile"  (change)="onFileSelect($event)" hidden/>
             <!-- our custom upload button -->
                <label for="actual-btn">Browse...</label>
            <!-- name of file chosen -->
                <span id="file-chosen">{{file_name}}</span>    
             </div>
             <div class="help-block">
                <span class="help-block__text">Upload pcap file</span>
              </div>
            
          </div>
          
            </div>
        </div>

    </div>
     </div>
     <div class="row" style="margin-top: 25px;"></div>
    <div class="row p-b20">
    <div class="col-2">
        <button class="btn btn--primary" type="submit" >Submit Request</button>
    </div>

    <footer class="footer" style="padding-right: 16px; margin-top: 20px;">
        <div class="footer__legal">
            <div class="row">
                <div class="col-md-2">
                    @ 2023 Cisco Systems, Inc.
                </div>
                <div class="col-md-6">

                </div>
                <div class="col-md-4">
                    <a href="https://www.cisco.com/c/en/us/about/legal/privacy-full.html" style="padding-left: 185px;
                    font-weight: 700;color: #1D69CC;">Privacy policy</a>
                
                    <a href="https://www.cisco.com/c/en/us/about/legal/terms-conditions.html" style="padding-left: 18px;
                    font-weight: 700;color: #1D69CC;">Terms of service</a>
                </div>    
            </div>
        </div>
    </footer>
   
        <div class="col-10">
           

        <div tabindex="0" class="alert alert--state-success mb-10" *ngIf="showsuccess">
            <div class="alert__icon icon-good"></div>
            <div class="alert__message"><strong>Success.</strong> {{showSuccessMessage}}</div>
            <a tabindex="0" class="alert__icon icon-close" (click)="closeSuccess()"></a>
        </div>
        <div tabindex="0" class="alert alert--state-danger mb-10" *ngIf="showerror">
            <div class="alert__icon icon-critical-stop"></div>
            <div class="alert__message"><strong>Error.</strong> {{showErrorMessage}}</div>
            <a tabindex="0" class="alert__icon icon-close" (click)="closeError()"></a>
        </div>
        </div>
    </div>
</form>

